import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const companyInfo = [
  { label: '会社名', value: '株式会社Peach' },
  { label: '代表者名', value: '山本 萌々子' },
  { label: '所在地', value: '大阪府大阪市浪速区敷津西１－５－２０ ラフィナート７０４号室' },
  { label: '電話番号', value: '090-6901-0787' },
  { label: 'メールアドレス', value: 'accounting@peach-sys.com' },
  { label: '設立', value: '2024年（登記変更手続き中）' },
  { label: '事業内容', value: '各種システムソフトウェア等の開発・制作・配信 / アプリケーションソフトの開発・制作・配信 / インターネットによる広告業及び広告代理店' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <section className="relative pt-36 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://readdy.ai/api/search-image?query=abstract%20colorful%20pink%20green%20emerald%20gradient%20glass%20crystal%20geometric%20shapes%20technology%20background%20fresh%20peach%20tones%20vibrant%20bokeh%20light%20effects%20artistic%20ultra%20high%20quality%20modern%20IT%20company&width=1920&height=700&seq=about001&orientation=landscape" alt="about bg" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-white"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <p className="text-xs font-semibold tracking-widest text-pink-300 uppercase mb-3">About Us</p>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-4">会社概要</h1>
          <p className="text-white/70 text-sm max-w-xl mx-auto">大阪発のフレッシュなITカンパニー</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-12 items-start mb-16">
            <div className="lg:w-2/5 w-full">
              <div className="rounded-2xl overflow-hidden h-72 w-full">
                <img src="https://readdy.ai/api/search-image?query=abstract%20colorful%20digital%20art%20pink%20green%20emerald%20gradient%20glass%20crystal%20spheres%20technology%20particles%20fresh%20peach%20tones%20vibrant%20bokeh%20light%20effects%20artistic%20ultra%20high%20quality%20modern%20IT%20company%20osaka%20japan&width=800&height=600&seq=about002&orientation=landscape" alt="company" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <div className="lg:w-3/5 w-full">
              <p className="text-xs font-semibold tracking-widest text-pink-400 uppercase mb-3">Our Story</p>
              <h2 className="text-2xl md:text-3xl font-black text-gray-800 mb-5">フレッシュな発想で、<br />ビジネスに新しい価値を</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                株式会社Peachは、大阪を拠点とするITカンパニーです。みずみずしい桃のように、フレッシュで活力あるサービスを提供することをモットーに、中小企業様・個人事業主様のデジタル化を総合的にサポートしています。
              </p>
              <p className="text-gray-500 text-sm leading-relaxed mb-8">
                システム開発・アプリ制作・インターネット広告の3つの柱を軸に、お客様のビジネス課題に寄り添い、最適なITソリューションをご提案します。
              </p>
              <div className="inline-flex items-center gap-2 bg-pink-50 border border-pink-100 rounded-full px-4 py-2">
                <i className="ri-map-pin-line text-pink-400 text-sm"></i>
                <span className="text-xs text-gray-600">大阪府大阪市浪速区</span>
              </div>
            </div>
          </div>

          {/* Company Info Table */}
          <div className="bg-gray-50 rounded-2xl border border-gray-100 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-pink-50 to-emerald-50">
              <h3 className="font-bold text-gray-800">会社情報</h3>
            </div>
            <div className="divide-y divide-gray-100">
              {companyInfo.map((item) => (
                <div key={item.label} className="flex flex-col sm:flex-row px-6 py-4 gap-2">
                  <span className="sm:w-36 text-xs font-semibold text-gray-400 uppercase tracking-wide flex-shrink-0 pt-0.5">{item.label}</span>
                  <span className="text-gray-700 text-sm leading-relaxed">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 p-5 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-3">
            <i className="ri-information-line text-amber-500 text-lg mt-0.5"></i>
            <p className="text-amber-700 text-sm leading-relaxed">
              <strong>【重要】</strong>現在、登記変更手続き中につき、一部情報が更新されていない場合がございます。ご不便をおかけし誠に申し訳ございません。最新情報については直接お問い合わせください。
            </p>
          </div>

          <div className="mt-10 text-center">
            <Link to="/contact" className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-gradient-to-r from-pink-400 to-rose-500 text-white font-semibold px-8 py-3.5 rounded-full hover:opacity-90 transition-opacity text-sm">
              <i className="ri-mail-send-line"></i>お問い合わせ
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
